import {
  DrawerRoot,
  DrawerContent,
  DrawerBody,
  DrawerBackdrop,
} from '@/components/ui/drawer';
import { ReactNode } from 'react';

interface SidebarDrawerProps {
  isOpen: boolean | undefined;
  onClose: (() => void) | undefined;
  children: ReactNode;
}

export function SidebarDrawer({
  isOpen = false,
  onClose,
  children,
}: SidebarDrawerProps) {
  return (
    <DrawerRoot
      placement="start"
      open={isOpen}
      onOpenChange={(e) => (e.open ? null : onClose?.())}
    >
      <DrawerBackdrop />
      <DrawerContent>
        <DrawerBody p={0}>{children}</DrawerBody>
      </DrawerContent>
    </DrawerRoot>
  );
}
